import request from '@/utils/request';

export default {
    getActionTypes: async({ dispatch, commit }) => {
        await request({
            method: 'get',
            url: '/action-types'
        }).then(res => {
            if (res.data) {
                commit('SET_ACTION_TYPES', res.data);
            }
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.error) {
                dispatch('alert/addMessage', {
                    message: error.response.data.error
                }, { root: true });
            }
        });
    },

    getActionLogs: async({ dispatch, commit }, params) => {
        await request({
            method: 'get',
            url: '/action-logs',
            params: {
                ...Object.select(
                    params, ['startDate', 'endDate', 'page']
                ),
                q: params.userId || '',
                types: JSON.stringify(params.types)
            }
        }).then(res => {
            if (res.data) {
                commit('SET_PAGINATION', {
                    page: res.data.page,
                    totalPages: res.data.totalPages
                });
                commit('SET_ACTION_LOGS', res.data.items);
            }
        }).catch(error => {
            if(error.response && error.response.data && error.response.data.error) {
                dispatch('alert/addMessage', {
                    message: error.response.data.error
                }, { root: true });
            }
        });
    },

    editActions: async({ dispatch }, data) => {
        await request({
            method: 'put',
            url: '/action',
            data
        }).then(() => {
            dispatch('alert/addMessage', {
                type: 'success',
                message: 'success'
            }, { root: true });
        }).catch(error => {
            if (error.response && error.response.data && error.response.data.error) {
                dispatch('alert/addMessage', {
                    message: error.response.data.error
                }, { root: true });
            }
        });
    }
};
